import styled from 'styled-components';
import USER_SELL_TRACTOR_IMAGE_MAIN from '../../../../../assets/images/userSellTractor/sellTractorMain.png';

export const FreeOfCharge = () => {
  return (
    <FreeOfChargeContainer>
      <FreeOfChargeTitle>{'일주일 만에 팔리는\n플루바 직거래!'}</FreeOfChargeTitle>
      <FreeOfChargeImage imageUrl={USER_SELL_TRACTOR_IMAGE_MAIN} />
    </FreeOfChargeContainer>
  );
};

const FreeOfChargeContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FreeOfChargeTitle = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const FreeOfChargeImage = styled.div<{ imageUrl: string }>`
  width: 200px;
  height: 165px;
  background: ${(props) => `url(${props.imageUrl}) transparent 50% / cover no-repeat;`};
`;
